import { useRef, useState } from "react";
import { ImagePlus, Trash2, RefreshCw } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, fileUrl } from "@/lib/api";

const OK = ["image/jpeg", "image/png", "image/webp"];

export const ImageUpload = ({ value, onChange, testid = "image-upload", label = "Gambar", compact = false }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = async (e) => {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (!f) return;
    if (!OK.includes(f.type)) return toast.error("Format harus JPG, JPEG, PNG, atau WebP");
    if (f.size > 5 * 1024 * 1024) return toast.error("Ukuran gambar maksimal 5 MB");
    const fd = new FormData();
    fd.append("file", f);
    setBusy(true);
    try {
      const { data } = await api.post("/upload", fd);
      onChange(data.path);
      toast.success("Gambar berhasil diunggah");
    } catch (err) {
      toast.error(`Unggah gagal: ${errMsg(err)}`);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="space-y-2" data-testid={testid}>
      <input ref={ref} type="file" accept=".jpg,.jpeg,.png,.webp" className="hidden" onChange={pick} data-testid={`${testid}-input`} />
      {value ? (
        <div className="flex items-start gap-3">
          <img src={fileUrl(value)} alt={label} className={`${compact ? "h-16" : "h-28"} max-w-[220px] rounded-md border object-contain bg-slate-50`} data-testid={`${testid}-preview`} />
          <div className="flex flex-col gap-1">
            <button type="button" onClick={() => ref.current?.click()} className="flex items-center gap-1 text-xs font-semibold text-[#0A192F] hover:underline" data-testid={`${testid}-replace`}><RefreshCw className="h-3 w-3" />Ganti</button>
            <button type="button" onClick={() => onChange(null)} className="flex items-center gap-1 text-xs font-semibold text-red-600 hover:underline" data-testid={`${testid}-remove`}><Trash2 className="h-3 w-3" />Hapus</button>
          </div>
        </div>
      ) : (
        <button type="button" disabled={busy} onClick={() => ref.current?.click()} data-testid={`${testid}-btn`}
          className="flex items-center gap-2 rounded-md border border-dashed border-slate-300 px-3 py-2 text-xs font-semibold text-slate-600 hover:border-amber-400 hover:text-amber-700 disabled:opacity-60">
          <ImagePlus className="h-4 w-4" />{busy ? "Mengunggah..." : `Unggah ${label}`}
        </button>
      )}
    </div>
  );
};
